import { GameModes, PlayPositions, PlaySessionTypes, ScoreFieldTypes } from "../../enums";
import { boolOrIntCodec } from "../../validation/codecs";
import { enumCodec, mixed, optional, required, t, timestampCodec } from "../../validation/validator";
import { CreatePlaySessionRequestSchema, CreatePlaySessionResponseSchema } from "./playSessionSchemas";

export const GetUserSessionsRequestSchema = mixed([
  required({
    user_id: t.string,
  }),
  optional({
    from_date: timestampCodec,
    to_date: timestampCodec,
    play_position: enumCodec(PlayPositions),
    game_mode: enumCodec(GameModes),
    session_type: enumCodec(PlaySessionTypes),
    is_completed: t.boolean,
    offset: t.number,
    limit: t.number,
    play_session_ids: t.array(t.number),
  }),
]);

export const GetUserSessionsResponseSchema = t.array(
  required({
    play_session_id: t.number,
    title: t.union([t.string, t.null]),
    created_at: t.string,
    updated_at: t.string,
    byb_iq: t.union([t.number, t.null]),
    total_score: t.union([t.number, t.null]),
    total_gameplay_duration: t.union([t.number, t.null]),
    experience_gained: t.number,
    game_mode: enumCodec(GameModes),
    session_type: enumCodec(PlaySessionTypes),
    play_position: t.union([enumCodec(PlayPositions), t.null]),
    is_completed: boolOrIntCodec,
    session_targets: t.type({
      // Todo - Made a dedicated codec for this targets type to reduce duplication
      [ScoreFieldTypes.GAMEPLAY_DURATION]: t.union([t.number, t.null]),
      [ScoreFieldTypes.TOTAL_SCORE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.SCAN_SCORE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.SCAN_RATE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.SCAN_TIMING]: t.union([t.number, t.null]),
      [ScoreFieldTypes.CRITICAL_SCANS]: t.union([t.number, t.null]),
      [ScoreFieldTypes.CRITICAL_SCAN_SCORE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.PASSES_SCORE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.PASSES_MADE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.PASSES_SUCCEEDED]: t.union([t.number, t.null]),
      [ScoreFieldTypes.PASSES_PACKING_RATE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.SHOTS_MADE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.SHOTS_SUCCEEDED]: t.union([t.number, t.null]),
      [ScoreFieldTypes.TACKLES_MADE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.TACKLES_SUCCEEDED]: t.union([t.number, t.null]),
      [ScoreFieldTypes.LABELS_MADE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.LABELS_SUCCEEDED]: t.union([t.number, t.null]),
      [ScoreFieldTypes.RECEIVALS_MADE]: t.union([t.number, t.null]),
      [ScoreFieldTypes.RECEIVALS_SUCCEEDED]: t.union([t.number, t.null]),
      [ScoreFieldTypes.AWARENESS_SCORE]: t.union([t.number, t.null]),
    }),
    user_id: t.number,
    doc_id: t.union([t.string, t.null]),
  })
);

export type GetUserSessionsRequest = t.TypeOf<typeof GetUserSessionsRequestSchema>;
export type GetUserSessionsResponse = t.TypeOf<typeof GetUserSessionsResponseSchema>;

// Client API
export const SessionApis = {
  Sessions: {
    CreatePlaySession: {
      Name: "sessions-createPlaySession",
      Request: CreatePlaySessionRequestSchema,
      Response: CreatePlaySessionResponseSchema,
    },
    GetUserSessions: {
      Name: "sessions-getUserSessions",
      Request: GetUserSessionsRequestSchema,
      Response: GetUserSessionsResponseSchema,
    },
  },
};
